import * as React from 'react';
import { CustomSubmitButton, CustomSubmitButtonType } from 'soprasteria-ui-library';
import { useAuth } from '../../../../App';
import { ISaveIOrthodonticReferral, IOrthodonticReferralAnswer } from '../../../../models/IOrthodonticReferral';
import { OrthodonticReferralAdministrationApi } from '../../../../api/OrthodonticReferralAdministrationApi';
import { useHistory } from 'react-router';
import { ORTHODONTIC_REFERRAL } from '../../../../utils/RouteConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { OrthodonticReferralResponseApi } from '../../../../api/OrthodonticReferralResponseApi';
import { AutoSave } from '../../../AutoSave/AutoSave';

interface IOrthodonticReferralSaveButton {
    orthodonticReferralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
    canClose: boolean;
}

export const OrthodonticReferralSaveButton: React.FunctionComponent<IOrthodonticReferralSaveButton> = ({ changeErrorMessage, changeSuccessMessage, orthodonticReferralId, getOrthodonticReferral, canClose }) => {

    const auth = useAuth();
    const administrationApi = new OrthodonticReferralAdministrationApi(auth);
    const responseApi = new OrthodonticReferralResponseApi(auth);
    const [isOrthodonticReferralSaving, setIsOrthodonticReferralSaving] = React.useState<boolean>(false);
    const history = useHistory();
    const saveButtonId = "save-orthodontic-referral-button";

    const saveOrthodonticReferral = (data: any) => {
        if (canClose) {
            saveOrthodonticReferralAnswer(data);
        } else {
            saveOrthodonticReferralForm(data);
        }
    }

    const saveOrthodonticReferralAnswer = (data: IOrthodonticReferralAnswer) => {
        if (orthodonticReferralId) {
            setIsOrthodonticReferralSaving(true);
            responseApi.saveOrthodonticReferralAnswer(data, () => {
                getOrthodonticReferral(orthodonticReferralId);
                changeSuccessMessage("Ortodontiremissen har sparats")
            }, (error) => {
                changeErrorMessage(error);
            }, () => {
                setIsOrthodonticReferralSaving(false);
            });
        }
    }

    const saveOrthodonticReferralForm = (data: ISaveIOrthodonticReferral) => {
        setIsOrthodonticReferralSaving(true);
        administrationApi.saveOrthodonticReferral(data, (newReferralId) => {
            if (orthodonticReferralId === undefined || orthodonticReferralId === 0) {
                history.replace(`${ORTHODONTIC_REFERRAL}/${newReferralId}`);
            }
            getOrthodonticReferral(newReferralId);
            changeSuccessMessage("Ortodontiremissen har sparats");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsOrthodonticReferralSaving(false);
        });
    }

    return (
        <>
            <AutoSave saveButtonId={saveButtonId} />
            <CustomSubmitButton onButtonSubmit={saveOrthodonticReferral} buttonType={CustomSubmitButtonType.alternative} isLoading={isOrthodonticReferralSaving} id={saveButtonId}><FontAwesomeIcon icon={faSave} /> Spara</CustomSubmitButton>
        </>
    )
}